import React, { useState } from 'react';
import Icon from 'components/AppIcon';
import Image from 'components/AppImage';

const TeamMembers = () => {
  const [selectedMember, setSelectedMember] = useState(null);
  const [filter, setFilter] = useState('all');

  const teamMembers = [
  {
    id: 1,
    name: "Dr. Marie-Claire KOUASSI",
    role: "Directrice Générale & Fondatrice",
    specialty: "leadership",
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1cabeee76-1763296842628.png",
    alt: "Professional headshot of Dr. Marie-Claire KOUASSI, CEO and Founder, wearing business attire with confident leadership expression",
    expertise: ["Strategic Leadership", "Business Transformation", "Innovation Management"],
    experience: "18+ années",
    certifications: ["MBA", "PMP", "Six Sigma Black Belt"],
    bio: "Visionnaire et leader expérimentée, Dr. Kouassi guide CRF Perfection vers l'excellence opérationnelle et l'innovation stratégique.",
    contact: { linkedin: "#", email: "marie.kouassi@crfperfection.com" }
  },
  {
    id: 2,
    name: "Jean-Baptiste AKOTO",
    role: "Directeur Technique & IA",
    specialty: "ai",
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_13b0f081c-1763296841959.png",
    alt: "Professional headshot of Jean-Baptiste AKOTO, Technical Director and AI specialist, in modern tech environment",
    expertise: ["Intelligence Artificielle", "Machine Learning", "Data Science"],
    experience: "12+ années",
    certifications: ["AI/ML Certified", "Google Cloud Professional", "Microsoft Azure Expert"],
    bio: "Expert en IA et transformation digitale, Jean-Baptiste développe des solutions technologiques avancées pour nos clients.",
    contact: { linkedin: "#", email: "jean.akoto@crfperfection.com" }
  },
  {
    id: 3,
    name: "Fatima BENALI",
    role: "Responsable RH & Formation",
    specialty: "hr",
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1767c5c6f-1763296841434.png",
    alt: "Professional headshot of Fatima BENALI, HR and Training Director, with warm approachable expression in office setting",
    expertise: ["Gestion RH", "Formation Professionnelle", "Développement des Talents"],
    experience: "10+ années",
    certifications: ["CHRP", "Formation Certifiante", "Leadership Coach"],
    bio: "Passionnée par le développement humain, Fatima accompagne les entreprises dans leur transformation RH et culturelle.",
    contact: { linkedin: "#", email: "fatima.benali@crfperfection.com" }
  },
  {
    id: 4,
    name: "Thomas MARTIN",
    role: "Consultant Senior Marketing Digital",
    specialty: "marketing",
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_12e19810b-1763293307748.png",
    alt: "Professional headshot of Thomas MARTIN, Senior Digital Marketing Consultant, in creative marketing workspace",
    expertise: ["Marketing Digital", "SEO/SEM", "Social Media Strategy"],
    experience: "8+ années",
    certifications: ["Google Ads Certified", "HubSpot Expert", "Facebook Blueprint"],
    bio: "Stratège marketing digital créatif, Thomas aide les entreprises à amplifier leur présence et impact en ligne.",
    contact: { linkedin: "#", email: "thomas.martin@crfperfection.com" }
  },
  {
    id: 5,
    name: "Aminata TRAORE",
    role: "Chef de Projet Digital",
    specialty: "project",
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1ab5959e8-1763296840705.png",
    alt: "Professional headshot of Aminata TRAORE, Digital Project Manager, with organized workspace and digital tools visible",
    expertise: ["Management de Projets", "Transformation Digitale", "Agilité"],
    experience: "7+ années",
    certifications: ["PMP", "Scrum Master", "PRINCE2"],
    bio: "Experte en gestion de projets complexes, Aminata assure la livraison réussie de nos solutions digitales innovantes.",
    contact: { linkedin: "#", email: "aminata.traore@crfperfection.com" }
  },
  {
    id: 6,
    name: "David CHEN",
    role: "Analyste Recherche & Études",
    specialty: "research",
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_11454b071-1763296842991.png",
    alt: "Professional headshot of David CHEN, Research and Studies Analyst, surrounded by research materials and analytical tools",
    expertise: ["Études de Marché", "Analyse de Données", "Recherche Stratégique"],
    experience: "6+ années",
    certifications: ["Market Research Society", "SPSS Advanced", "Tableau Expert"],
    bio: "Analyste rigoureux et méthodique, David fournit les insights stratégiques qui guident nos recommandations clients.",
    contact: { linkedin: "#", email: "david.chen@crfperfection.com" }
  }];


  const filterOptions = [
  { value: 'all', label: 'Toute l\'Équipe', icon: 'Users' },
  { value: 'leadership', label: 'Direction', icon: 'Crown' },
  { value: 'ai', label: 'IA & Tech', icon: 'Brain' },
  { value: 'hr', label: 'RH & Formation', icon: 'GraduationCap' },
  { value: 'marketing', label: 'Marketing', icon: 'Megaphone' },
  { value: 'project', label: 'Projets', icon: 'FolderOpen' },
  { value: 'research', label: 'Recherche', icon: 'Search' }];


  const filteredMembers = filter === 'all' ?
  teamMembers :
  teamMembers?.filter((member) => member?.specialty === filter);

  return (
    <section className="py-20 px-4 sm:px-6 lg:px-8 bg-gradient-to-br from-gray-50 to-blue-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <div className="inline-flex items-center space-x-3 bg-red-50 text-red-600 px-6 py-3 rounded-full font-semibold text-sm mb-8">
            <Icon name="Users" size={20} />
            <span>Rencontrez Notre Équipe</span>
          </div>
          <h2 className="text-4xl font-bold text-gray-900 mb-6">Les Visages de l'Excellence</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Chaque membre apporte une expertise unique et une passion partagée pour transformer vos défis en réussites durables
          </p>
        </div>

        {/* Filter Buttons */}
        <div className="flex flex-wrap items-center justify-center gap-4 mb-12">
          {filterOptions?.map((option) =>
          <button
            key={option?.value}
            onClick={() => setFilter(option?.value)}
            className={`inline-flex items-center space-x-2 px-6 py-3 rounded-xl font-medium transition-all duration-200 ${
            filter === option?.value ?
            'bg-red-600 text-white shadow-lg transform scale-105' :
            'bg-white text-gray-700 hover:bg-red-50 hover:text-red-600 shadow-md hover:shadow-lg'}`
            }>

              <Icon name={option?.icon} size={18} />
              <span>{option?.label}</span>
            </button>
          )}
        </div>

        {/* Team Members Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {filteredMembers?.map((member) =>
          <div key={member?.id} className="group">
              <div className="bg-white rounded-3xl p-8 shadow-lg hover:shadow-2xl transform hover:-translate-y-2 transition-all duration-300 border border-gray-100 relative overflow-hidden">
                {/* Background Gradient on Hover */}
                <div className="absolute inset-0 bg-gradient-to-br from-red-50 to-orange-50 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                
                <div className="relative z-10">
                  {/* Profile Image */}
                  <div className="relative mb-6">
                    <div className="w-24 h-24 mx-auto rounded-full overflow-hidden ring-4 ring-gray-100 group-hover:ring-red-200 transition-all duration-300">
                      <Image
                      src={member?.image}
                      alt={member?.alt}
                      className="w-full h-full object-cover" />

                    </div>
                    <div className="absolute -bottom-2 -right-2 w-8 h-8 bg-red-600 rounded-full flex items-center justify-center">
                      <Icon name="CheckCircle" size={16} className="text-white" />
                    </div>
                  </div>

                  {/* Member Info */}
                  <div className="text-center space-y-4">
                    <div>
                      <h3 className="text-xl font-bold text-gray-900 mb-1">{member?.name}</h3>
                      <p className="text-red-600 font-semibold text-sm">{member?.role}</p>
                    </div>

                    {/* Expertise Tags */}
                    <div className="flex flex-wrap justify-center gap-2">
                      {member?.expertise?.slice(0, 2)?.map((skill, index) =>
                    <span key={index} className="px-3 py-1 bg-blue-100 text-blue-700 text-xs font-medium rounded-full">
                          {skill}
                        </span>
                    )}
                    </div>

                    {/* Experience */}
                    <div className="flex items-center justify-center space-x-4 text-sm text-gray-600">
                      <div className="flex items-center space-x-1">
                        <Icon name="Calendar" size={14} />
                        <span>{member?.experience}</span>
                      </div>
                      <div className="flex items-center space-x-1">
                        <Icon name="Award" size={14} />
                        <span>{member?.certifications?.length} certif.</span>
                      </div>
                    </div>

                    {/* Bio Preview */}
                    <p className="text-gray-600 text-sm leading-relaxed line-clamp-3">
                      {member?.bio}
                    </p>
                  </div>

                  {/* Action Buttons */}
                  <div className="mt-6 pt-6 border-t border-gray-100 flex justify-center space-x-3">
                    <button
                    onClick={() => setSelectedMember(member)}
                    className="flex-1 inline-flex items-center justify-center space-x-2 bg-red-600 hover:bg-red-700 text-white px-4 py-2 rounded-lg font-medium transition-colors duration-200">

                      <Icon name="User" size={16} />
                      <span>Profil</span>
                    </button>
                    <button className="w-10 h-10 bg-gray-100 hover:bg-blue-50 text-gray-600 hover:text-blue-600 rounded-lg flex items-center justify-center transition-colors duration-200">
                      <Icon name="Mail" size={16} />
                    </button>
                    <button className="w-10 h-10 bg-gray-100 hover:bg-blue-50 text-gray-600 hover:text-blue-600 rounded-lg flex items-center justify-center transition-colors duration-200">
                      <Icon name="Linkedin" size={16} />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>

        {/* Member Detail Modal */}
        {selectedMember &&
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
            <div className="bg-white rounded-3xl p-8 max-w-2xl w-full max-h-[90vh] overflow-y-auto">
              <div className="flex items-start justify-between mb-6">
                <div className="flex items-center space-x-4">
                  <div className="w-16 h-16 rounded-full overflow-hidden">
                    <Image
                    src={selectedMember?.image}
                    alt={selectedMember?.alt}
                    className="w-full h-full object-cover" />

                  </div>
                  <div>
                    <h3 className="text-2xl font-bold text-gray-900">{selectedMember?.name}</h3>
                    <p className="text-red-600 font-semibold">{selectedMember?.role}</p>
                  </div>
                </div>
                <button
                onClick={() => setSelectedMember(null)}
                className="w-8 h-8 bg-red-100 hover:bg-red-200 text-red-600 rounded-full flex items-center justify-center transition-colors duration-200">

                  <Icon name="X" size={16} />
                </button>
              </div>

              <div className="space-y-6">
                <p className="text-gray-700 leading-relaxed">{selectedMember?.bio}</p>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-3">Expertise</h4>
                    <div className="space-y-2">
                      {selectedMember?.expertise?.map((skill, index) =>
                    <div key={index} className="flex items-center space-x-2">
                          <Icon name="CheckCircle" size={16} className="text-green-500" />
                          <span className="text-gray-700">{skill}</span>
                        </div>
                    )}
                    </div>
                  </div>

                  <div>
                    <h4 className="font-semibold text-gray-900 mb-3">Certifications</h4>
                    <div className="space-y-2">
                      {selectedMember?.certifications?.map((cert, index) =>
                    <div key={index} className="flex items-center space-x-2">
                          <Icon name="Award" size={16} className="text-blue-500" />
                          <span className="text-gray-700">{cert}</span>
                        </div>
                    )}
                    </div>
                  </div>
                </div>

                <div className="pt-6 border-t border-gray-100">
                  <div className="flex space-x-4">
                    <button className="flex-1 inline-flex items-center justify-center space-x-2 bg-red-600 hover:bg-red-700 text-white px-6 py-3 rounded-xl font-semibold transition-colors duration-200">
                      <Icon name="MessageSquare" size={20} />
                      <span>Contacter</span>
                    </button>
                    <button className="px-6 py-3 border border-gray-300 hover:border-red-300 text-gray-700 hover:text-red-600 rounded-xl font-semibold transition-colors duration-200">
                      <Icon name="Calendar" size={20} className="inline mr-2" />
                      Planifier RDV
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        }
      </div>
    </section>);

};

export default TeamMembers;